import React from 'react'

import * as Yup from 'yup'
import { BasicForm } from '../../../../core/components/form'
import { usePutForm, useFetch } from '../../../../hooks/manager/client'
import { useHistory, useParams } from 'react-router-dom'

import { useCacheCountry, getCountriesForSelect } from '../../../../hooks/cache/country'

import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

import { v4 } from 'uuid'

import Form from './form'

const ValidationSchema = Yup.object().shape({
  first_name: Yup.string().required('First Name cannot be blank.'),
  last_name: Yup.string().required('Last Name cannot be blank.'),
  type: Yup.string().required('Type cannot be blank.'),
  country: Yup.number().required('Cannot be blank'),
  currency: Yup.number().required('Cannot be blank'),
  rush_percent: Yup.number().required('Cannot be blank').typeError('Must be a number')
})

const Formulario = () => {
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)
  const update = usePutForm(id)
  const history = useHistory()

  const { data: countriesData } = useCacheCountry()
  const countries = getCountriesForSelect(countriesData)

  function handleSubmit (values, bag) {
    values.prices.forEach((e) => delete e.id)
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const getInitialPrices = (prices) => {
    return (prices || []).map((p) => ({
      id: v4(),
      service: p.service,
      category: p.category,
      language: p.language,
      language_pair: p.language_pair,
      language_family: p.language_family,
      unit: p.unit,
      amount: p.amount
    }))
  }

  const initialValues = {
    type: data.client.type,
    name: data.client.name,
    country: data.client.country ? data.client.country.id : '',
    currency: data.client.currency ? data.client.currency.id : '',
    website: data.client.website,
    notes: data.client.notes,
    first_name: data.client.first_name,
    last_name: data.client.last_name,
    phone: data.client.phone,
    email: data.client.email,
    skype: data.client.skype,
    timezone: data.client ? data.client.timezone : '',
    prices: getInitialPrices(data.client.prices),
    rush_percent: data.client.rush_percent,
    satisfaction_survey: data.client.satisfaction_survey
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='EDIT CLIENT'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={(formik) => (
        <Form formik={formik} countries={countries} />
      )}
    />
  )
}

export default Formulario
